<template>
  <div class="form-floating flex-grow-1 mb-3">
    <input
      :id="name"
      class="form-control"
      :class="{ 'is-invalid': errors }"
      :type="type"
      :step="step"
      :maxlength="max"
      :name="name"
      :placeholder="label"
      :value="value"
      :readonly="readonly"
      :required="required"
      :data-attribute="attribute"
      @keypress="isLetter($event)"
      @change="$emit('update:data', $event)"
    />
    <div v-for="(error, index) in errors" :key="index" class="invalid-feedback" role="alert">
      <strong>{{ error }}</strong>
    </div>
    <label :for="name">{{ label }} </label>
  </div>
</template>

<script>
export default {
  props: {
    attribute: {
      type: String,
      default: null,
    },
    errors: {
      type: Array,
      default: null,
    },
    name: {
      type: String,
      default: '',
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    required: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      default: '',
    },
    step: {
      type: String,
      default: null,
    },
    type: {
      type: String,
      default: 'text',
    },
    value: {
      type: [String, Number],
      default: '',
    },
    max: {
      type: Number,
      default: null,
    },
  },
  emits: ['update:data'],
  setup() {
    const isLetter = (e) => {
      let char = String.fromCharCode(e.keyCode);
      if (/^[^<^>]+$/.test(char)) return true;
      else e.preventDefault();
    };
    return {
      isLetter,
    };
  },
};
</script>
